import { Link } from "react-router-dom";
import kanban from "../../assets/kanban.webp";
import fleet from "../../assets/fleet/fleet.webp";
import bquiz from "../../assets/bquiz/bquiz.webp";
import elevate from "../../assets/elevate/elevate.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { slugify } from "../../helpers";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { PiMedalFill } from "react-icons/pi";
import { FaStar } from "react-icons/fa6";
import { AiFillThunderbolt } from "react-icons/ai";
import { DiCodeigniter } from "react-icons/di";

export const Projects = () => {
  const location = useLocation();
  const [selectedTag, setSelectedTag] = useState(null);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [location]);

  const tags = [
    { name: "Initiator", icon: <AiFillThunderbolt />, id: "initiator" },
    { name: "Task Based Creation", icon: <DiCodeigniter />, id: "task" },
    { name: "Contributor", icon: <FaStar />, id: "contributor" },
    { name: "Large Scale Creation", icon: <PiMedalFill />, id: "large" },
  ];

  const projects = [
    {
      name: "elevate",
      src: elevate,
      text: "Elevate Health - Admin & Patient Portal",
      stacks: [
        "React Js",
        "TypeScipt",
        "One Signal",
        "Firebase",
        "Redux Toolkit",
        "AntD",
        "Custom CSS",
        "Apex Charts",
      ],
      icons: [
        <AiFillThunderbolt size={15} />,
        <PiMedalFill size={15} />,
        <FaStar size={15} />,
      ],
      tags: ["initiator", "large", "contributor"],
    },
    {
      name: "bquiz",
      src: bquiz,
      text: "BQuiz - AI-Powered Quiz Creation Platform",
      stacks: [
        "React",
        "Next Js",
        "Redux Toolkit",
        "TypeScipt",
        "Tailwind CSS",
        "Socket io",
      ],
      icons: [
        <AiFillThunderbolt size={15} />,
        <PiMedalFill size={15} />,
        <FaStar size={15} />,
      ],
      tags: ["initiator", "large", "contributor"],
    },
    {
      name: "fleet",
      src: fleet,
      text: "FMS - Fleet Tracking & Management Platform",
      stacks: [
        "React",
        "Redux Toolkit",
        "Google APIs",
        "TypeScipt",
        "Tailwind CSS",
        "Socket io",
      ],
      icons: [
        <AiFillThunderbolt size={15} />,
        <PiMedalFill size={15} />,
        <FaStar size={15} />,
      ],
      tags: ["initiator", "large", "contributor"],
    },
    {
      name: "control",
      src: "https://www.eginnovations.com/blog/wp-content/uploads/2021/08/System-day-top-image.png",
      text: "PL Admin Panel - Role Based Administrative Access",
      stacks: [
        "React",
        "Tailwind CSS",
        "Redux Toolkit",
        "JavaScript",
        "TypeScript",
        "Api Integeration",
      ],
      icons: [
        <AiFillThunderbolt size={15} />,
        <PiMedalFill size={15} />,
        <FaStar size={15} />,
      ],
      tags: ["initiator", "large", "contributor"],
    },
    {
      name: "ecommerce",
      src: "https://thumbs.dreamstime.com/b/fans-crowd-vector-flat-minimal-icon-isolated-eps-illustration-design-long-shadow-118522920.jpg",
      text: "Encore - Multi-Programs Fans Application",
      stacks: [
        "React",
        "JavaScript",
        "TypeScipt",
        "Redux",
        "Tailwind CSS",
        "Socket io",
      ],
      icons: [<PiMedalFill size={15} />, <FaStar size={15} />],
      tags: ["large", "contributor"],
    },
    {
      name: "kanban",
      src: kanban,
      text: "Kanban - Project Management Board",
      stacks: ["React", "Tailwind CSS", "Redux Toolkit", "JavaScript", "CSS 3"],
      icons: [<AiFillThunderbolt size={15} />, <DiCodeigniter size={15} />],
      tags: ["initiator", "task"],
    },
    /* {
      name: "comment app",
      src: "https://i.ytimg.com/vi/2GjQzBWdDAc/sddefault.jpg",
      text: "Comment Cascade - Infinite Comment Nesting",
      stacks: ["React", "Tailwind CSS", "Redux Toolkit", "JavaScript"],
      icons: [<AiFillThunderbolt size={15} />, <DiCodeigniter size={15} />],
      tags: ["initiator", "task"],
    }, */
  ];

  const filteredProjects = selectedTag
    ? projects.filter((project) => project.tags.includes(selectedTag))
    : projects;

  return (
    <div className="w-full min-h-screen bg-body px-5 sm:px-28">
      {/* Header Section - Blog Style */}
      <div className="sm:pt-36 pt-24 w-full">
        <div className="mx-auto">
          <h1 className="text-[48px] sm:text-[56px] font-bold text-primary mb-4 tracking-tight">
            Projects
          </h1>
          <p className="text-[16px] sm:text-[18px] text-primary leading-relaxed mb-8 max-w-4xl">
            A collection of projects showcasing my work across healthcare, fleet
            management, quiz platforms, and more. Each project demonstrates
            clean code, modern design, and user-centric thinking.
          </p>

          {/* Filter Tags - Subtle Blog Style */}
          <div className="flex flex-wrap items-center gap-2 mb-8">
            <button
              onClick={() => setSelectedTag(null)}
              className={`text-sm px-2 lg:px-4 py-1.5 rounded-md transition-all duration-200 ${
                selectedTag === null
                  ? "bg-btn text-white"
                  : "bg-secondary text-primary hover:bg-primary-hover border border-tag"
              }`}
            >
              All
            </button>
            {tags?.map((tag) => {
              const isSelected = selectedTag === tag.id;
              return (
                <button
                  key={tag.id}
                  onClick={() => setSelectedTag(isSelected ? null : tag.id)}
                  className={`text-sm px-2 lg:px-4 py-1.5 rounded-md transition-all duration-200 flex items-center gap-1.5 ${
                    isSelected
                      ? "bg-btn text-white"
                      : "bg-secondary text-primary hover:bg-primary-hover border border-tag"
                  }`}
                >
                  {tag?.icon}
                  {tag?.name}
                </button>
              );
            })}
          </div>
        </div>
      </div>

      {/* Projects Grid - Blog Card Style */}
      <div className="w-full pb-20">
        <div className="mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {filteredProjects.map((project) => {
              return (
                <Link
                  key={project.name}
                  to={`/project/${slugify(project.text)}`}
                  className="group flex flex-col bg-secondary rounded-lg border border-tag overflow-hidden hover:border-btn transition-all duration-300 hover:shadow-md"
                >
                  {/* Image */}
                  <div className="relative h-[200px] w-full overflow-hidden bg-body">
                    <div className="absolute top-3 left-3 z-10">
                      <div className="flex items-center gap-1.5">
                        {project?.icons?.map((icon, idx) => {
                          return (
                            <div
                              key={idx}
                              className="rounded-full text-primary p-1.5 bg-secondary shadow-sm"
                            >
                              {icon}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                    <LazyLoadImage
                      src={project.src}
                      alt={project.name}
                      className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>

                  {/* Content */}
                  <div className="flex flex-col gap-3 p-3">
                    <h3 className="text-[20px] font-semibold text-primary group-hover:text-[var(--bg-btn)] transition-colors duration-200 line-clamp-2">
                      {project.text}
                    </h3>
                    <div className="flex flex-wrap gap-2 w-full">
                      {project?.stacks?.map((stack, id) => {
                        return (
                          <span
                            key={id}
                            className="px-2.5 whitespace-nowrap py-1 text-[10px] font-light border border-tag bg-body rounded-full text-primary"
                          >
                            {stack}
                          </span>
                        );
                      })}
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>

          {filteredProjects.length === 0 && (
            <div className="text-center py-20">
              <p className="text-primary text-lg">
                No projects found for this filter.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
